export default "__VITE_ASSET__DrzTFNRf__"